module.exports = __webpack_public_path__ + "c4da7e327d4efc89ea8aa1f6093a25dc.pdf";